import axios from "axios";
import type { VerifyData } from "~/lib/api/types/verify";

export async function verify(): Promise<VerifyData> {
    return (await axios.get<VerifyData>("/verify-master")).data;
}
